import useBoolean from "@hooks/useBoolean";

const useMenu = () => {
  const [isOpened, open, close, toggle] = useBoolean(false);

  return { isOpened, open, close, toggle };
};

export default useMenu;
